import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f4e3073"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-filter" }, null, -1 /* HOISTED */));
import { ElDivider, ElDropdown, ElDropdownMenu, } from "element-plus";
import { computed, ref, toRef } from "vue";
import Button from "../../ui/Button.vue";
import DropdownItemCheckbox from "../../ui/dropdown/DropdownItemCheckbox.vue";
import DisplayedCampaignVariantSelector from "./DisplayedCampaignVariantSelector.vue";
import { useComponentVariableMutableFilter } from "src/shared/store/component-variable-mutable/composables/useComponentVariableMutableSetFilter";
import { useComponentVariableAdvancedMasterSwitch } from "../composables/useComponentVaraiableAdvancedMasterSwitch";
import { useComponentMutable } from "src/shared/store/component-mutable/composables/useComponentMutable";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableToolbarFilterMenu',
    props: {
        componentMutableKey: {}
    },
    setup(__props) {
        const props = __props;
        const { componentVariableMutableFilter } = useComponentVariableMutableFilter(toRef(props, "componentMutableKey"));
        const showOnlyUsingDefaultValue = computed({
            get() {
                return componentVariableMutableFilter.value.showOnlyUsingDefaultValue;
            },
            set(value) {
                componentVariableMutableFilter.value.showOnlyUsingDefaultValue = value;
                if (value) {
                    componentVariableMutableFilter.value.showOnlyNotUsingDefaultValue = false;
                }
            },
        });
        const showOnlyNotUsingDefaultValue = computed({
            get() {
                return componentVariableMutableFilter.value.showOnlyNotUsingDefaultValue;
            },
            set(value) {
                componentVariableMutableFilter.value.showOnlyNotUsingDefaultValue = value;
                if (value) {
                    componentVariableMutableFilter.value.showOnlyUsingDefaultValue = false;
                }
            },
        });
        const showOnlyTranslatable = computed({
            get() {
                return componentVariableMutableFilter.value.showOnlyTranslatable;
            },
            set(value) {
                componentVariableMutableFilter.value.showOnlyTranslatable = value;
            },
        });
        const { componentMutable } = useComponentMutable(toRef(props, "componentMutableKey"));
        const campaignId = computed(() => {
            var _a;
            return (_a = componentMutable.value) === null || _a === void 0 ? void 0 : _a.campaign_id;
        });
        const isDropdownVisible = ref(false);
        const onVisibleChange = (visible) => {
            isDropdownVisible.value = visible;
        };
        const { showAdvanced, toggle } = useComponentVariableAdvancedMasterSwitch();
        const showAdvancedMasterSwitch = computed({
            get: () => showAdvanced(),
            set: () => {
                toggle();
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDropdown), {
                trigger: "click",
                "hide-on-click": "",
                "popper-class": "list list--drop-down list--drop-down--modern",
                placement: "bottom-end",
                onVisibleChange: onVisibleChange
            }, {
                dropdown: _withCtx(() => [
                    _createVNode(_unref(ElDropdownMenu), null, {
                        default: _withCtx(() => [
                            _createVNode(DropdownItemCheckbox, {
                                "icon-class": 'fa-regular fa-star-of-life',
                                label: 'Show Advanced',
                                modelValue: showAdvancedMasterSwitch.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((showAdvancedMasterSwitch).value = $event))
                            }, null, 8 /* PROPS */, ["modelValue"]),
                            _createVNode(_unref(ElDivider)),
                            _createVNode(DropdownItemCheckbox, {
                                "icon-class": 'fa-kit fa-variable-instance-linked',
                                label: 'Using default value',
                                modelValue: showOnlyUsingDefaultValue.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showOnlyUsingDefaultValue).value = $event))
                            }, null, 8 /* PROPS */, ["modelValue"]),
                            _createVNode(DropdownItemCheckbox, {
                                "icon-class": 'fa-kit fa-variable-instance-unlinked',
                                label: 'Not using default value',
                                modelValue: showOnlyNotUsingDefaultValue.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((showOnlyNotUsingDefaultValue).value = $event))
                            }, null, 8 /* PROPS */, ["modelValue"]),
                            _createVNode(_unref(ElDivider)),
                            _createVNode(DropdownItemCheckbox, {
                                "icon-class": 'far fa-language',
                                label: 'Translatable',
                                modelValue: showOnlyTranslatable.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((showOnlyTranslatable).value = $event))
                            }, null, 8 /* PROPS */, ["modelValue"]),
                            _createVNode(_unref(ElDivider)),
                            (campaignId.value)
                                ? (_openBlock(), _createBlock(DisplayedCampaignVariantSelector, {
                                    key: 0,
                                    "campaign-id": campaignId.value
                                }, null, 8 /* PROPS */, ["campaign-id"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                default: _withCtx(() => [
                    _createVNode(Button, {
                        shape: 'square',
                        level: 'menu',
                        "is-active": isDropdownVisible.value,
                        onClick: _cache[0] || (_cache[0] = ($event) => (isDropdownVisible.value = true))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_1
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["is-active"])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
